import React from "react";
import { FiCheck } from "react-icons/fi";

const PredictorCard = ({ item, isSelected, onCardClick }) => {
  const fullName = `${item?.firstName || ""} ${item?.lastName || ""}`.trim() || "Անհայտ";

  return (
    <div
      className={`relative w-full rounded-2xl border transition-all duration-200 p-5 flex flex-col justify-between items-center text-center cursor-pointer group ${
        isSelected
          ? "border-emerald-500 ring-2 ring-emerald-500/20 bg-emerald-50/20 shadow-md"
          : "border-slate-200/80 bg-white hover:border-slate-300 hover:shadow-md"
      }`}
      onClick={onCardClick}
    >
      {/* Selected Indicator */}
      {isSelected && (
        <div className="absolute top-3 right-3 w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center text-xs shadow-sm z-10">
          <FiCheck strokeWidth={3} size={12} />
        </div>
      )}

      {/* Avatar & Identity */}
      <div className="flex flex-col items-center w-full">
        <div className="relative mb-3">
          <img
            src={item?.image || "/defaultuserprofile.webp"}
            alt={fullName}
            onError={(e) => {
              e.target.src = "/defaultuserprofile.webp";
            }}
            className="w-20 h-20 rounded-full object-cover ring-4 ring-slate-100 shadow-sm bg-slate-50 group-hover:scale-105 transition-transform duration-200"
          />
        </div>

        {item._highlightResult?.firstName?.value ||
        item._highlightResult?.lastName?.value ? (
          <div className="flex items-center justify-center gap-1 flex-wrap text-sm sm:text-base font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
            <span
              className="highlighted"
              dangerouslySetInnerHTML={{
                __html: item._highlightResult?.firstName?.value || "",
              }}
            />
            <span
              className="highlighted"
              dangerouslySetInnerHTML={{
                __html: item._highlightResult?.lastName?.value || "",
              }}
            />
          </div>
        ) : (
          <h4 className="text-sm sm:text-base font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
            {fullName}
          </h4>
        )}

        {item?.degree && (
          <span className="text-xs font-medium text-slate-600 bg-slate-100 px-2.5 py-0.5 rounded-full mt-1.5 max-w-full truncate">
            {item.degree}
          </span>
        )}
      </div>

      {/* Optional Details */}
      {(item?.title || item?.description) && (
        <div className="mt-3 pt-3 border-t border-slate-100 w-full">
          {item?.title && (
            <p className="text-xs font-semibold text-slate-800 line-clamp-1 mb-0.5">
              {item.title}
            </p>
          )}
          {item?.description && (
            <p className="text-[11px] text-slate-500 line-clamp-2 leading-relaxed">
              {item.description}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default PredictorCard;
